<modal-layout-right>
    <p class="h3"
       modalTitle>{{data.title | translate}}</p>
    <div modalBody>
        <carousel class="default-swiper swiper-slide-per-view p-t-5"
                  [ngClass]="data.products.length > 1 ? 'p-l-5 p-r-5 p-b-11' : 'p-r-10 p-l-10 p-b'"
                  [slidesPerView]="'auto'"
                  [scrollbar]="{dragSize: 48}"
                  [style.--pc-slides-ceil]="pcSlidesCeil"
                  [style.--pc-slides]="pcSlides"
                  [style.--pc-gutter]="pcGutter"
                  [freeMode]="true">
            @for(product of data.products; track $index){
            <ng-template swiperSlide>
                <product [modelId]="product.id"
                         [gtmImpressionTrack]="{productId: product.id, position: $index+1, list: 'Shop this look', numberOfResults: data.products.length}"
                         [gtmTrackProductClick]="{productId: product.id, position: $index+1, list: 'Shop this look'}">
                </product>
            </ng-template>
            }
        </carousel>
    </div>
</modal-layout-right>